module.exports = __webpack_public_path__ + "img/13.8ae47c15.png";